import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'

class FormInput extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {
      labelClass: '',
      inputClass: 'form-control'
    }
  }

  componentWillMount() {
    if (this.props.required) {
      this.setState({ labelClass: 'required' })
      if (this.props.value.length == 0) {
        this.setState({ inputClass: 'form-control error' })
      }
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    if (this.props.required && value.length == 0) {
      this.setState({inputClass: 'form-control error'})
    } else {
      this.setState({inputClass: 'form-control'})
    }
    this.props.onChange({
      [name]: value
    });
  }

  render() {
    return (
      <div>
        <label className={this.state.labelClass}>{this.props.label}</label>
        <input type="text" className={this.state.inputClass} name={this.props.name} value={this.props.value} onChange={this.handleInputChange}></input>
      </div>
    )
  }
}

export default connect()(FormInput)


// WEBPACK FOOTER //
// ./app/javascript/components/components/FormInput.jsx